import React from 'react';
import { observer } from 'mobx-react-lite';
import ccss from '../../Styles/common.module.css';
import classNames from "./JsonOverlayView.module.css"
import { PrettyPrintedJsonObjectView } from './PrettyPrintedJsonObjectView';
import { ProcessInfo } from '../../State/ProcessInfo';
import { isRunningInExtensionsDevToolsPanel } from '../../Pages/devtools/isProcessRunningInExtensionPage';

export interface SetObjectToDisplayAsJson {
	setObjectToDisplayAsJson?: (object: unknown) => void;
}
export interface ObjectToDisplayAsJson {
	objectToDisplayAsJson: unknown;
};

export interface JsonOverlayViewParameters extends SetObjectToDisplayAsJson, ObjectToDisplayAsJson {};

export const JsonOverlayView = observer(({ objectToDisplayAsJson, setObjectToDisplayAsJson }: JsonOverlayViewParameters) => {
	const textToCopy = `\`\`\`json\n${JSON.stringify(objectToDisplayAsJson, null, '\t')}\n\`\`\``;
	const copyToClipboardViaClipboardApi = async () => {
		if (isRunningInExtensionsDevToolsPanel) {
			// A misguided chrome security policy prevents a devtools panel from copying to the clipboard.
			// An even more misguided, but fortuitous, chrome security policy allows a devtools panel to
			// run the deprecated `document.execCommand` function to execute the otherwise-forbidden copy.
			// So, if we're in a devtools panel, we have no choice but to use the deprecated API.
			const textArea = document.createElement('textarea');
			textArea.value = textToCopy;
			textArea.setAttribute('display', 'none');	
			document.body.appendChild(textArea);
			textArea.select();
			document.execCommand('copy');
			document.body.removeChild(textArea);
		} else {
			try {
				// Use the modern clipboard API to copy the div's contents to the clipboard
				await navigator.clipboard.writeText(textToCopy);
			} catch (e) {
				ProcessInfo.errorLog(`Could not copy to clipboard`, e);
			}
		}
	}
	if (objectToDisplayAsJson == null) return null;
	return (
		<div className={classNames.OverlayContainerElement}>
			<div className={classNames.OverlayInsertElement}>
				<div className={classNames.OverlayHeaderRow}>
					<button className={ccss.borderless} onClick={copyToClipboardViaClipboardApi}>📋 copy</button>
					<button className={ccss.borderless} onClick={() => { setObjectToDisplayAsJson?.(undefined); }}>✖</button>
				</div>
				<PrettyPrintedJsonObjectView objectToPrettyPrintAsJson={objectToDisplayAsJson} />
			</div>
		</div>
	);
});
